import type { DefaultDashboardDefinition } from './dashboard-definition';

export const storageLocationDashboard: DefaultDashboardDefinition = {
  id: "configuration.storage-location",
  appId: "configuration",
  name: "Storage Location dashboard",
  record: {
    separator: ".",
    suffix: "summary",
    placementIds: "static",
    placementSeparator: ".",
  },
  queryScope: {
    field: "storage_location_id",
    mode: "replace",
    duration: 1,
  },
  placements: [
    {
      id: "storage.branch-grants.default",
      widgetId: "storage.branch-grants",
      placement: {
        x: 0,
        y: 0,
        width: 6,
        height: 2,
      },
    },
    {
      id: "storage.details.default",
      widgetId: "storage.details",
      placement: {
        x: 6,
        y: 0,
        width: 6,
        height: 4,
      },
    },
  ],
};
